import React, {useRef, useEffect, useState} from "react";
import {Routes, Route} from 'react-router-dom';
import { useStateContext } from './context/stateContext';
import Home from './components/Home';
import Header from './components/Header';
import Footer from './components/Footer';
import Project from "./components/Project";
import { Toaster } from 'react-hot-toast';

import './styles/style.scss';

function App() {
  const {linkHovred, setLinkHovred} = useStateContext();
  const cursorRef=useRef();
  const cursorFollwerRef=useRef();
  const topBtnRef=useRef();
  const [x, setX] = useState(0);
  const [y, setY] = useState(0);

  const scrollToTop=()=>{
    window.scrollTo({
      top:0,
      left:0,
      behavior:"smooth"
    });
  }

  useEffect(() => {
    // click element under the custom cursor
    document.addEventListener('click', (e) => {
      // Check if the custom cursor is being clicked
      if (e.target.classList.contains('custom-cursor') || e.target.classList.contains('custom-cursor-follower')) {
        // Find the element underneath the cursor
        const elementUnderCursor = document.elementFromPoint(e.clientX, e.clientY);
        // Dispatch a click event on the underlying element
        elementUnderCursor.dispatchEvent(new MouseEvent('click', e));
      }
    });

    // set the position of the custom cursor
    document.addEventListener('mousemove', (e) => {
      cursorRef.current.classList.remove('hide');
      cursorFollwerRef.current.classList.remove('hide');
      function updateCursor() {
        setX(e.clientX);
        setY(e.clientY);
        requestAnimationFrame(updateCursor);
      }
      updateCursor();      
    });

    // show top button after 100vh height
    window.onscroll=()=>{
      if (window.scrollY > 600) {
        topBtnRef.current.classList.remove("hide");
      } else {
        topBtnRef.current.classList.add("hide");
      }
    }
  }, []);
  return (
    <>
      <div className="custom-cursor hide" ref={cursorRef} style={{transform:`translate(${x}px, ${y-1}px)`}}></div>
      <div className={`custom-cursor-follower hide`} ref={cursorFollwerRef} style={{transform:`translate(${x- (linkHovred?15:10)}px, ${y- (linkHovred?16:12)}px)`, width:`${linkHovred ? 40:30}px`, height:`${linkHovred ? 40:30}px`}}></div>
      <button
        ref={topBtnRef}
        className="to-top-button hide"
        onMouseLeave={()=>setLinkHovred(false)}
        onMouseEnter={()=>setLinkHovred(true)}
        onClick={scrollToTop}
      ></button>
      <Header/>
      <Toaster/>
      <Routes>
        <Route path="/*" element={<Home/>}/>
        <Route path="/project/:id" element={<Project/>}/>
      </Routes>
      <Footer/>
    </>
  );
}

export default App;
